import React from "react";
import DataTable from "react-data-table-component";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import CustomLoader from "components/Shared/CustomLoader";

import { useListEntityAuthorizationQuery } from "store/services/authorizationApi";

const EntityLvlAuthorizationListScreen = () => {
  const breadcrumbs = [{ title: "Authorizations" }];

  //   RTK Query
  const {
    data: authorizations,
    isLoading: loadingAuthorizations,
    error,
  } = useListEntityAuthorizationQuery("Active");

  const columns = [
    {
      name: "Level",
      selector: (row) => row?.level ?? "N/A",
    },
    {
      name: "Type",
      selector: (row) => row?.type ?? "N/A",
    },
    {
      name: "Role",
      selector: (row) => row?.role ?? "N/A",
    },
  ];

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingAuthorizations}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <DataTable
          columns={columns}
          data={authorizations}
          progressPending={loadingAuthorizations}
          progressComponent={<CustomLoader />}
          persistTableHead={true}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EntityLvlAuthorizationListScreen;
